import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WithTooltipComponent } from './with-tooltip.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [WithTooltipComponent],
  imports: [CommonModule,MatTooltipModule],
  exports: [WithTooltipComponent],
})
export class WithTooltipModule {}
